import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-717d4866"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row mt-3 mb-4" }
const _hoisted_3 = ["id"]
const _hoisted_4 = { class: "d-flex flex-column align-items-center flex-1 p-2" }
const _hoisted_5 = { class: "d-flex flex-column align-items-center" }
const _hoisted_6 = ["alt", "src"]
const _hoisted_7 = { class: "font-weight-bold lead text-primary text-upper" }
const _hoisted_8 = { class: "mb-0 lead" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_10 = { class: "col-md-4 col-xl-3" }
const _hoisted_11 = { class: "faq-menu" }
const _hoisted_12 = { class: "faq-category-menu" }
const _hoisted_13 = ["id"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "faq-category-subsubmenu" }
const _hoisted_16 = ["href"]
const _hoisted_17 = { class: "col-md-8 col-xl-9" }
const _hoisted_18 = { class: "faq-container" }
const _hoisted_19 = ["id"]
const _hoisted_20 = ["id"]
const _hoisted_21 = ["id"]
const _hoisted_22 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeroFaqBlock = _resolveComponent("HeroFaqBlock")!
  const _component_SelectButton = _resolveComponent("SelectButton")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_ScrollPanel = _resolveComponent("ScrollPanel")!
  const _directive_vue_intersect = _resolveDirective("vue-intersect")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.vm.heroFaqBlock)
      ? (_openBlock(), _createBlock(_component_HeroFaqBlock, {
          key: 0,
          vm: _ctx.vm.heroFaqBlock
        }, null, 8, ["vm"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          id: `cat_${_ctx.selectedCategory.faqId}`,
          class: "col-12"
        }, [
          _createVNode(_component_SelectButton, {
            modelValue: _ctx.selectedCategory,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedCategory) = $event)),
            class: "row m-0 faq-categories",
            "data-key": "faqId",
            options: _ctx.vm.faqHeadCategories,
            onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onHeadCategoryChanged())),
            unselectable: false
          }, {
            option: _withCtx(({ option }) => [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  (option.icon)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        alt: option.icon.alt,
                        class: "mb-2 category-icon",
                        src: option.icon.url
                      }, null, 8, _hoisted_6))
                    : _createCommentVNode("", true),
                  _createElementVNode("p", _hoisted_7, _toDisplayString(option.title), 1),
                  _createElementVNode("p", _hoisted_8, _toDisplayString(option.description), 1)
                ])
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "options"]),
          _hoisted_9
        ], 8, _hoisted_3),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_ScrollPanel, { style: {"width":"100%","height":"60vh","overflow":"hidden"} }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedCategory?.subCategories, (subCategory) => {
                    return (_openBlock(), _createBlock(_component_Panel, {
                      collapsed: 
									_ctx.menuItemCollapsed[`${_ctx.selectedCategory?.faqId}_${subCategory.id}`]
								,
                      "onUpdate:collapsed": ($event: any) => ((
									_ctx.menuItemCollapsed[`${_ctx.selectedCategory?.faqId}_${subCategory.id}`]
								) = $event),
                      key: `menu_${_ctx.selectedCategory?.faqId}_${subCategory.id}`,
                      class: "faq-category-submenu"
                    }, {
                      header: _withCtx(() => [
                        _createElementVNode("div", {
                          id: `${_ctx.selectedCategory?.faqId}_${subCategory.id}`,
                          class: ""
                        }, _toDisplayString(subCategory.title), 9, _hoisted_13)
                      ]),
                      icons: _withCtx(() => [
                        (_ctx.selectedCategory?.subCategories?.length > 1)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "p-panel-header-icon p-link mr-2",
                              onClick: ($event: any) => (
											_ctx.toggleMenuItemCollapse(`${_ctx.selectedCategory?.faqId}_${subCategory.id}`)
										)
                            }, [
                              _createElementVNode("i", {
                                class: _normalizeClass(
												_ctx.isMenuItemCollapsed(`${_ctx.selectedCategory?.faqId}_${subCategory.id}`)
													? 'pi pi-chevron-down'
													: 'pi pi-chevron-up'
											)
                              }, null, 2)
                            ], 8, _hoisted_14))
                          : _createCommentVNode("", true)
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("ul", _hoisted_15, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subCategory.subSubCategories, (subSubCategory) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: `menu_${_ctx.selectedCategory?.faqId}_${subCategory.id}_${subSubCategory.id}`,
                              class: _normalizeClass(["faq-category-header-item", {
											active:
												_ctx.firstVisibleHeader ===
												`${_ctx.selectedCategory?.faqId}_${subCategory.id}_${subSubCategory.id}`,
										}])
                            }, [
                              _createElementVNode("a", {
                                class: "faq-category-header-item-link",
                                href: `#${_ctx.selectedCategory?.faqId}_${subCategory.id}_${subSubCategory.id}`
                              }, [
                                _createElementVNode("span", null, _toDisplayString(subSubCategory.title), 1)
                              ], 8, _hoisted_16)
                            ], 2))
                          }), 128))
                        ])
                      ]),
                      _: 2
                    }, 1032, ["collapsed", "onUpdate:collapsed"]))
                  }), 128))
                ])
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            (_openBlock(), _createElementBlock("div", {
              key: `content_${_ctx.selectedCategory.faqId}`,
              class: "faq-items p-2"
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedCategory.subCategories, (subCategory) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: `content_${_ctx.selectedCategory.faqId}_${subCategory.id}`,
                  class: "faq-sub-items"
                }, [
                  _createElementVNode("h4", {
                    id: `${_ctx.selectedCategory.faqId}_${subCategory.id}`,
                    class: "mb-0"
                  }, _toDisplayString(subCategory.title), 9, _hoisted_19),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subCategory.subSubCategories, (subSubCategory) => {
                    return (_openBlock(), _createElementBlock("ul", {
                      key: `content_${_ctx.selectedCategory.faqId}_${subCategory.id}_${subSubCategory.id}`,
                      class: "faq-sub-sub-items"
                    }, [
                      _createElementVNode("li", null, [
                        _withDirectives((_openBlock(), _createElementBlock("a", {
                          id: `${_ctx.selectedCategory.faqId}_${subCategory.id}_${subSubCategory.id}`,
                          class: "hidden-category-anchor"
                        }, [
                          _createTextVNode(_toDisplayString(subCategory.title), 1)
                        ], 8, _hoisted_20)), [
                          [_directive_vue_intersect, 
											_ctx.onIntersectionObserved(
												`${_ctx.selectedCategory.faqId}_${subCategory.id}_${subSubCategory.id}`
											)
										]
                        ]),
                        _createElementVNode("p", {
                          id: `header_${_ctx.selectedCategory.faqId}_${subCategory.id}_${subSubCategory.id}`,
                          class: "faq-sub-sub-header"
                        }, _toDisplayString(subSubCategory.title), 9, _hoisted_21),
                        _createElementVNode("ul", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subSubCategory.faqItems, (item) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: `item_${item.id}`,
                              class: "faq-item"
                            }, [
                              _createElementVNode("a", {
                                class: "p-button p-button-arrow p-button-outlined justify-content-between ml-0 mb-1",
                                href: item.url
                              }, _toDisplayString(item.question), 9, _hoisted_22)
                            ]))
                          }), 128))
                        ])
                      ])
                    ]))
                  }), 128))
                ]))
              }), 128))
            ]))
          ])
        ])
      ])
    ])
  ], 64))
}